import { openDB, type DBSchema } from "idb";
import type { SermonRecord } from "../shared/sermons";

interface SermonOfflineSchema extends DBSchema {
  sermons: {
    key: string;
    value: {
      id: string;
      sermon: SermonRecord;
      savedAt: number;
    };
  };
  mutations: {
    key: string;
    value: {
      id: string;
      sermonId: string;
      payload: Partial<SermonRecord> & { documentVersion: number };
      createdAt: number;
    };
    indexes: { sermonId: string };
  };
}

const database = openDB<SermonOfflineSchema>("bible-alone-sermons", 1, {
  upgrade(db) {
    db.createObjectStore("sermons", { keyPath: "id" });
    const mutations = db.createObjectStore("mutations", { keyPath: "id" });
    mutations.createIndex("sermonId", "sermonId");
  },
});

export async function cacheSermon(sermon: SermonRecord): Promise<void> {
  const db = await database;
  await db.put("sermons", { id: sermon.id, sermon, savedAt: Date.now() });
}

export async function cachedSermon(id: string): Promise<SermonRecord | null> {
  const db = await database;
  return (await db.get("sermons", id))?.sermon ?? null;
}

export async function queueSermonMutation(
  sermonId: string,
  payload: Partial<SermonRecord> & { documentVersion: number },
): Promise<void> {
  const db = await database;
  await db.put("mutations", {
    id: sermonId,
    sermonId,
    payload,
    createdAt: Date.now(),
  });
}

export async function queuedSermonMutations(sermonId?: string) {
  const db = await database;
  return sermonId
    ? db.getAllFromIndex("mutations", "sermonId", sermonId)
    : db.getAll("mutations");
}

export async function removeQueuedSermonMutation(id: string): Promise<void> {
  const db = await database;
  await db.delete("mutations", id);
}
